import type {
  ContentModSection,
  ContentModSubSection
} from '~/contracts/srp/Seo';
import { type Size, type SizeWithScale } from './constants';

export const multiple = (factor: number) => (size: Size) => ({
  height: size.height * factor,
  width: size.width * factor
});

export const double = multiple(2);

export const triple = multiple(3);

export const contentImage =
  (ext: string) => (imageName: string) => (assetsUrl: string) =>
    `${assetsUrl}/traffic-assets/content-mods/${imageName}.${ext}`;

export const contentJpg = contentImage('jpg');

export const getSrcSet =
  (sizeList: SizeWithScale[]) =>
  (ext: string) =>
  (imageURL: string) =>
  (assetsUrl: string) =>
    sizeList.reduce(
      (p, c) =>
        `${p ? `${p},` : ''} ${contentImage(ext)(
          `${imageURL}.${c.width}x${c.height}`
        )(assetsUrl)} ${c.scale}`,
      ''
    );

export const sortSectionPriority = (
  a: ContentModSection | ContentModSubSection,
  b: ContentModSection | ContentModSubSection
) => a.sectionPriority - b.sectionPriority;
